import { useMemo } from 'react';

import { useCookiePrefAsync } from '#src/app/shared/hooks/session';
import { isLoaded } from '#src/app/shared/utils/async';

type Result = ModelHookResult<{
	isAllowedByCookiePrefs: boolean;
}>;

export function useIsAllowedByCookiePrefs(): Result {
	const marketingCookies = useCookiePrefAsync('marketing');

	const isAllowedByCookiePrefs = useMemo(
		() => isLoaded(marketingCookies) && marketingCookies.value,
		[marketingCookies],
	);
	return {
		data: {
			isAllowedByCookiePrefs,
		},
	};
}
